import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateSaleStatus } from '../../../../../redux/sale/action';
import { useNavigate } from 'react-router-dom';
import { Commas, getDateFormate } from '../../../../Common/AllDateTimeReleventFormate';
import SendOTP from './SendOTP';
import AddAddressModel from './AddAddressModel';
import ConfirmModal from '../../../../Common/ConfirmModal';

export default function SaleOrderstatus({ data }) {
    const laung = localStorage.getItem("laung");
    const [lan] = useState(laung ?? "en");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [otp, setOTP] = useState('');
    const [modal, setModal] = useState(false);

    // 🔴 Confirmation modal states
    const [confirmModal, setConfirmModal] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pendingAction, setPendingAction] = useState(null);

    // ---------------- CONFIRM HANDLER ----------------
    const openConfirm = (action, msg) => {
        setPendingAction(() => action);
        setConfirmMsg(msg);
        setConfirmModal(true);
    };

    const handleConfirm = () => {
        if (pendingAction) pendingAction();
        setPendingAction(null);
        setConfirmModal(false);
    };

    // ---------------- ACTIONS ----------------

    const PayExpert = () => {
        // navigate(`/${lan}/salecontract/${data?.id}`, {
        //     state: { approvefrom: "buyer", type: "sale" },
        // });
        const state = {
            id: data?.id,
            sale_id: data?.id,
            type: 3,
            type_of_post: "sale",
            post_id: data?.id,
            post_price: data?.price,
        };

        const data1 = {
            "sale_request_id": data?.id,
            "type": "2",
            image: "",
            url: `/${lan}/account/paymentmethodpage`,
            state: state,
        };
        console.log("data1", data1);

        navigate(data1?.url, {
            state: {
                orderdetails: {
                    ...data1?.state,
                },
            },
        });
    };

    const DeliveryStatus = () => {
        dispatch(updateSaleStatus({
            sale_request_id: data?.id,
            type: "1",
            status: "5",
            id: data?.id,
        }));
    };

    const ItemDelivered = () => {
        dispatch(updateSaleStatus({
            type: "1",
            status: "6",
            sale_request_id: data?.id,
            id: data?.id,
        }));
    };

    const Transactioncomplete = () => {
        dispatch(updateSaleStatus({
            type: "1",
            status: "7",
            sale_request_id: data?.id,
            otp: otp,
            id: data?.id,
        }));
    };

    const AddAddressApihit = (values) => {
        dispatch(updateSaleStatus({
            type: "3",
            sale_request_id: data?.id,
            address: values?.address,
            id: data?.id,
        }));
    };

    const handleAddAddress = (values) => {
        openConfirm(() => AddAddressApihit(values), "Are you sure you want to add this address?");
    };

    const getStatusByValue = (status) =>
        data?.status_history?.find(item => item.status == status);

    const status4 = getStatusByValue(4);
    const status5 = getStatusByValue(5);
    const status6 = getStatusByValue(6);
    const status7 = getStatusByValue(7);

    return (
        <div className="col-md-5">
            <div className='status-rightsec'>
                <div className='order-status'>
                    <h6>Order status</h6>
                    {data?.status > 3 && <p className='paid'>Amount Paid</p>}
                </div>

                <div className='status-history'>

                    {/* STEP 1 */}
                    <div className="status-first">
                        <div className={`number ${data?.status > 2 ? 'complete' : 'processing'}`}>
                            <span>1</span>
                        </div>
                        <div className='status-right'>
                            <h6>Order Accepted</h6>
                        </div>
                    </div>

                    {/* STEP 2 */}
                    <div className="status-first">
                        <div className={`number ${data?.status > 3 ? 'complete' : 'processing'}`}>
                            <span>2</span>
                        </div>
                        <div className='status-right'>
                            <h6>{data.is_mine ? "Amount Received" : "Amount Paid"}</h6>
                            <h2>${Commas(data?.price)}</h2>

                            {data?.status == 3 && data?.is_mine != 1 &&
                                <span
                                    className='status-btn mark-delivered'
                                    onClick={() => openConfirm(PayExpert, "Are you sure you want to make the payment?")}
                                >
                                    Pay Now
                                </span>
                            }

                            {data?.status == 4 && data?.is_mine != 1 &&
                                <span
                                    className='status-btn mark-delivered'
                                    onClick={() => setModal(true)}
                                >
                                    Add Address
                                </span>
                            }

                            {data?.address && <p className='status-p'>Address: {data?.address}</p>}
                            {status4 && <p className='status-p'>Paid on: {getDateFormate(status4?.created_on)}</p>}
                        </div>
                    </div>

                    {/* STEP 3 */}
                    <div className="status-first">
                        <div className={`number ${data?.status > 4 ? 'complete' : 'processing'}`}>
                            <span>3</span>
                        </div>
                        <div className='status-right'>
                            <h6>Out for Delivery</h6>

                            {data?.status == 4 && data?.is_mine == 1 &&
                                <span
                                    className='status-btn mark-delivered'
                                    onClick={() => openConfirm(DeliveryStatus, 'Are you sure you want to mark it as "Out for delivery"?')}
                                >
                                    Update Out for Delivery
                                </span>
                            }

                            {status5 && <p className='status-p'>On: {getDateFormate(status5?.created_on)}</p>}
                        </div>
                    </div>

                    {/* STEP 4 */}
                    <div className="status-first">
                        <div className={`number ${data?.status > 5 ? 'complete' : 'processing'}`}>
                            <span>4</span>
                        </div>
                        <div className='status-right'>
                            <h6>Item Delivered</h6>
                            {(data?.status >= 5 && data?.is_mine == 0 && data?.status == 6) &&
                                <div className='deliveryotp-sec d-flex align-items-center '>
                                    <div>
                                        <h6>Delivery OTP</h6>
                                        <p className='status-p'>Please provide the OTP to the seller once the item is delivered</p>
                                    </div>
                                    <span className='status-btn mark-delivered otp-number'>{data?.delivery_otp}</span>
                                </div>
                            }

                            {data?.status == 5 && data?.is_mine != 1 &&
                                <span
                                    className='status-btn mark-delivered'
                                    onClick={() => openConfirm(ItemDelivered, 'Are you sure you want to mark it as "Item delivered"?')}
                                >
                                    Mark Delivered
                                </span>
                            }

                            {status6 && <p className='status-p'>On: {getDateFormate(status6?.created_on)}</p>}
                        </div>
                    </div>

                    {/* STEP 5 */}
                    <div className="status-first">
                        <div className={`number ${data?.status > 6 ? 'complete' : 'processing'}`}>
                            <span>5</span>
                        </div>
                        <div className='status-right'>
                            <h6>Transaction Complete</h6>

                            {data?.status == 6 && data?.is_mine == 1 &&
                                <div className='deliveryotp-sec '>
                                    <h6>Delivery OTP</h6>
                                    <p className='status-p'>
                                        Please enter the OTP to complete the transaction.
                                    </p>
                                    <SendOTP
                                        setOTP={setOTP}
                                        Transactioncomplete={() => openConfirm(Transactioncomplete, 'Are you sure you want to mark this transaction as "Completed"?')}
                                    />
                                </ div >
                            }

                            {status7 && <p className='status-p'>On: {getDateFormate(status7?.created_on)}</p>}
                        </div>
                    </div>

                </div>
            </div>

            {/* ADD ADDRESS MODAL */}
            <AddAddressModel
                data={data}
                modal={modal}
                setModal={setModal}
                AddAddressApihit={handleAddAddress}
            />

            {/* CONFIRM MODAL */}
            <ConfirmModal
                isOpen={confirmModal}
                toggle={() => setConfirmModal(false)}
                // title="Do you want to update the status?"
                title=""
                message={confirmMsg}
                onConfirm={handleConfirm}
            />
        </div>
    );
}
